export default {
    api: {
        aboutTo:
            'トークンの削除後、<0>{{apiName}}</0>は<1>{{partnerName}}</1>にアクセスできなくなります。',
        submit: 'トークンを削除',
        title: '{{apiName}}のトークンを削除',
    },
    employee: {
        afterRevoking: '<0>{{employeeName}}</0>の退会後、',
        afterRevokingDocumentsAndHistory:
            '対象メンバーが作成した書類や操作履歴などはそのまま保持されます。',
        afterRevokingNoMoreAccess:
            '対象メンバーは自社のデータにアクセスできなくなります。',
        details: '対象メンバー',
        detailsCompanyPartner: '会社名: <0>{{partnerName}}</0>',
        detailsCompanyPartnerAndAccount:
            '会社名: <0>{{partnerName}}</0> <1>{{accountName}}</1>',
        detailsName: 'メンバー名：<0>{{employeeName}}</0>',
        revoke: 'メンバーを退会',
        revokingAutomaticallyDiscards:
            '注意：退会させると、 <0>{{employeeName}}</0> が作成した <1>{{scheduledSendingOrderCount}}</1> 件の送付予約が取り消されます。',
        title: 'メンバーを退会',
    },
};
